import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=b305b16a&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b305b16a')) {
      api.createRecord('b305b16a', component.options)
    } else {
      api.reload('b305b16a', component.options)
    }
    module.hot.accept("./ProductItem.vue?vue&type=template&id=b305b16a&", function () {
      api.rerender('b305b16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/ProductItem.vue"
export default component.exports